import Image from 'src/components/image';
import { Stack } from '@mui/material';

export default function EmptyState() {
  return (
    <Stack alignItems="center" justifyContent="center" marginY="auto">
      <Image src="/assets/illustrations/empty-state.svg" alt="empty-state" />
    </Stack>
  );
}
